import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import imgKkp from '../../../assets/images/logo_kkp.jpg'
import srcArial from '../../../assets/custom/font/arial/arial.ttf'
import srcArialBold from '../../../assets/custom/font/arial/ARIBL0.ttf'
import { useCallback, useEffect, useMemo, useState } from "react";
import KapalService from "../../../services/kapal/KapalService";
import { formatDateStringLocalDateINA } from "../../../utilities/Utils";

Font.register({ family: 'Arial', src: srcArial })
Font.register({ family: 'Arial-Bold', src: srcArialBold })

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 42,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 115,
        height: 100,
    },
    headingTtd: {
        width: 250,
        height: 123,
    },
    table: {
        display: "table",
        width: "auto"
    },
    tableRow: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    tableCol: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 1
    },
    text: {
        fontSize: 10,
        fontFamily: "Arial"
    },
    textBold: {
        fontSize: 12,
        fontFamily: "Arial-Bold"
    }
})

const LHPInspeksiKapal = ({ dataDisposisi, dataPpmKapal }) => {

    let kapalService = useMemo(() => new KapalService(), [])
    const [inspeksi, setInspeksi] = useState(null)
    const [masterKapal, setMasterKapal] = useState(null)

    const fetchAllData = useCallback(async () => {
        if (!dataPpmKapal?.nomorAjuKapal || !dataDisposisi?.noTugas) {
            console.log("data Kapal atau data disposisi kosong")
            return
        }

        try {
            const results = await Promise.allSettled([
                kapalService.getInspeksiData(dataPpmKapal.nomorAjuKapal),
                kapalService.getMasterKapalById(dataPpmKapal.idKapal)
            ])

            const [resInspeksi, resMasterKapal] = results
            const getData = (res, fallback = []) =>
                res.status === "fulfilled"
                    ? res.value?.data?.data ?? res.value?.data ?? fallback
                    : fallback;

            setInspeksi(getData(resInspeksi))
            setMasterKapal(getData(resMasterKapal))
        } catch (error) {
            console.log(error)
        }
    }, [dataDisposisi, dataPpmKapal, kapalService])

    useEffect(() => {
        let isMounted = true;
        if (!dataPpmKapal) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [dataPpmKapal, fetchAllData]);

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={[styles.table, { marginBottom: 3 }]}>
                    <View style={[styles.tableRow, { borderBottom: 2, borderBottomStyle: 'solid' }]}>
                        <View style={[styles.tableCol, { width: '25%' }]}>
                            <Image style={styles.headingImg} src={imgKkp} />
                        </View>
                        <View style={[styles.tableCol, { width: '70%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'center', color: '#7895be' }]}>KEMENTERIAN KELAUTAN DAN PERIKANAN</Text>
                            <Text style={[styles.text, { fontSize: 14, textAlign: 'center', color: '#7895be' }]}>BADAN PENGENDALIAN DAN PENGAWASAN MUTU</Text>
                            <Text style={[styles.text, { fontSize: 14, textAlign: 'center', color: '#7895be' }]}>HASIL KELAUTAN DAN PERIKANAN</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>JALAN MEDAN MERDEKA TIMUR NO. 16</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>JAKARTA 10110, KOTAK POS 4130 JKP 10041</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>TELEPON (021) 3519070 (LACAK), FAKSIMILE (021) 3513282</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>LAMAN www.kkp.go.id</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 5 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'center' }]}>LAPORAN HASIL INSPEKSI PENGENDALIAN MUTU</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table]}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Nama Kapal</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '74%', borderTop: 1, borderLeft: 1, borderRight: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataPpmKapal && dataPpmKapal.namaKapal}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Pemilik Kapal</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '74%', borderTop: 1, borderLeft: 1, borderRight: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{masterKapal && masterKapal.pemilik}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Penanggung Jawab Kapal</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '74%', borderTop: 1, borderLeft: 1, borderRight: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{masterKapal && masterKapal.penanggungJawab}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '99%', borderTop: 1, borderLeft: 1, borderRight: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Tim Inspeksi</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Ketua</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '34%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%', borderTop: 1, borderLeft: 1, borderRight: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>No Reg ......./Insp/....</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Anggota</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '34%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%', borderTop: 1, borderLeft: 1, borderRight: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>No Reg ......./Insp/....</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '34%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%', borderTop: 1, borderLeft: 1, borderRight: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>No Reg ......./Insp/....</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Tgl Inspeksi</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '34%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{inspeksi && formatDateStringLocalDateINA(inspeksi.tglInspeksi)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%', borderTop: 1, borderLeft: 1, borderRight: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1, borderBottom: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Mekanisme Inspeksi</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '74%', borderTop: 1, borderLeft: 1, borderRight: 1, borderBottom: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{inspeksi && (inspeksi.tipeInspeksi === '1' ? 'Inspeksi Di Tempat' : 'Inspeksi Jarak Jauh')}</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { paddingTop: 9 }]}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '4%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>No</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Parameter Inspeksi</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '34%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Hasil Inspeksi</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '36%', borderTop: 1, borderLeft: 1, borderRight: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Kriteria Penyimpangan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '4%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>1</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Pembongkaran Ikan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '34%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '36%', borderTop: 1, borderLeft: 1, borderRight: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '4%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>2</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Standar fasilitas penanganan dan/atau pengolahan, penyimpanan Ikan di kapal perikanan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '34%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '36%', borderTop: 1, borderLeft: 1, borderRight: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '4%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>3</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Standar prosedur penanganan dan/atau pengolahan, penyimpanan ikan di kapal perikanan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '34%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '36%', borderTop: 1, borderLeft: 1, borderRight: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '4%', borderTop: 1, borderLeft: 1, borderBottom: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>4</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1, borderBottom: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Standar penerapan Hazard Analysis Critical Control Point (HACCP)*</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '34%', borderTop: 1, borderLeft: 1, borderBottom: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '36%', borderTop: 1, borderLeft: 1, borderRight: 1, borderBottom: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { paddingTop: 9 }]}>
                    <View style={[styles.tableRow, { marginBottom: 10 }]}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>*Khusus kapal pembeku</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { paddingTop: 9 }]}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '4%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>No</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '30%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Petugas Inspeksi</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Tanda Tangan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '46%', borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Penanggung Jawab Kapal</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '4%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>1</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '30%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Tono, S.Pi</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '46%', borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '4%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>2</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '30%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Jono, S.Pi</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '46%', borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '4%', borderTop: 1, borderLeft: 1, borderBottom: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>3</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '30%', borderTop: 1, borderLeft: 1, borderBottom: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Mono, S.Pi</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%', borderTop: 1, borderLeft: 1, borderBottom: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '46%', borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>{masterKapal && masterKapal.penanggungJawab}</Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    )
}

export default LHPInspeksiKapal